$(document).ready(function () {
    if ($(window).width() <= 1200) {
        $('.hamburger-icon a.icon-nav').on('click', function (e) {
            e.preventDefault();
            $(this).toggleClass('menu-open close-menu-mb');
            if ($(this).hasClass('menu-open')) {
                $('html').addClass('translate-overlay');
            } else {
                $('html').removeClass('translate-overlay');
            }
        });

        $('.cart-icon a').on('click', function (e) {
            e.preventDefault(); 
            $('html').toggleClass('cart-show');
        });

        $(document).on('click', function (e) {
            if (!$(e.target).closest('.cart-icon a, .mini-cart-container').length) {
                $('html').removeClass('cart-show');
            }
        });
    }
});

$(document).ready(function() {
  function isHomePage() {
    return window.location.pathname === "/" || window.location.href === "https://www.makeupcityshop.com/";
  }

  function isMobileView() {
    return $(window).width() <= 1200;
  }

  if (isHomePage()) {
    $('.search-mb .icon-search').on('click', function() {
      if (isMobileView()) {
        $('html').addClass('search-open');
      }
    });

    $('.search-mb .close-search').on('click', function() {
      if (isMobileView()) {
        $('html').removeClass('search-open');
      }
    });

    $(window).on('resize', function() {
      if ($(window).width() > 1200) {
        $('html').removeClass('search-open');
      }
    });
  }
});